import {
    newModalFromString,
    newModalFromSelector
} from '../components/modal';

import WashingSymbols from './washingSymbols';
import { updateProductDetailSlider } from './detail';
import { getPidValue } from './helpers/baseHelpers';
import NotifyHelper from './notify';
import SmartGiftHelper from './smartGiftHelper';
import { updateProductDetailUrl } from 'util/url';
import { getGtmData } from '../analytics/helpers/helper';
import { createCookie } from '../util/common';
import { generatePromoAnimatedStrip } from './productBox';
import { mobileSlickArrowPrev, mobileSlickArrowNext } from '../components/slickArrows';
import { handleSizebayInjection } from '../quickAdd';

let bonusProductModal;

function throttle (func, delay) {
    let time = 0;

    return function (...args) {
        let now = Date.now();

        if (now - time >= delay) {
            func.apply(this, args);
            time = now;
        }
    };
}

function setVHUnit () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', throttle(() => {
    setVHUnit();
}, 500));
setVHUnit();

export function setEqualInnerHeight (slider, selector) {
    let maxHeight = 0;
    const $elements = $(slider).find(selector);

    $elements.each(function () {
        const h = $(this).outerHeight();
        if (h > maxHeight) {
            maxHeight = h;
        }
    });

    $elements.css('height', maxHeight + 'px');
}

export function setSliderEdgeClasses (slick, currentSlide = 0) {
    const current = currentSlide || 0;
    const lastSlideIndex = slick.slideCount - slick.options.slidesToShow;
    const $slickList = $(slick.$list);

    $slickList.removeClass('is-start is-end is-middle');

    if (current === 0) {
        $slickList.addClass('is-start');
    } else if (current >= lastSlideIndex) {
        $slickList.addClass('is-end');
    } else {
        $slickList.addClass('is-middle');
    }
}

export function checkReviewCount ($slider, slickInstance) {
    if (!$slider.find('.slick-slide').length) return;

    const instance = slickInstance || $slider.slick('getSlick');
    const slideCount = instance.slideCount;
    let slidesToShow = instance.options.slidesToShow;
    const windowWidth = $(window).width();

    instance.options.responsive.forEach((breakpoint) => {
        if (windowWidth < breakpoint.breakpoint) {
            slidesToShow = breakpoint.settings.slidesToShow;
        }
    });

    $slider.removeClass('is-single-review is-few-reviews is-multiple-reviews');

    if (slideCount === 1) {
        $slider.addClass('is-single-review');
    } else if (slideCount < slidesToShow) {
        $slider.addClass('is-few-reviews');
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} type - type of filter selected
 */

const crossSellSlider = () => {
    if ($('#crossSellContainerMinicart .js-cross-product').length) {
        $('#crossSellContainerMinicart').slick({
            slide: '.js-cross-product',
            dots: false,
            infinite: false,
            draggable: false,
            speed: 500,
            slidesToShow: 2.1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.minicart .prev-button-crosssell'),
            nextArrow: $('.minicart .next-button-crosssell'),
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 1,
                    infinite: false,
                    draggable: true
                }
            }]
        });
    }
};

const attributeSelect = (selectedValueUrl, $productContainer, type = '_', imagesShouldUpdate = true) => {
    var validUrl;
    if (selectedValueUrl) {
        try {
            validUrl = new URL(selectedValueUrl);
            validUrl = validUrl.protocol === 'http:' || validUrl.protocol === 'https:';
        } catch (_) {
            if (selectedValueUrl.indexOf('Product-Variation') !== -1) {
                validUrl = true;
            } else validUrl = false;
        }
    } else validUrl = false;
    if (selectedValueUrl && validUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: data => {
                handleVariantResponse(data, $productContainer, imagesShouldUpdate, type);
                handleSizeAvailabilityTooltips(data.product.variationAttributes);
                handleVariationUrlsSelectNotifyModal(data.product.variationAttributes[1].values);
                handleVariationComingSoonNotifyModal(data.product.variationAttributes[1].values);
                handleVariationCustomization(data.product, data.variation);
                updateOptions(data.product.options, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                handleLowInStock(data.product.variationAttributes, $productContainer);
                var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
                if (!isChoiceOfBonusProducts) {
                    updateProductVariationDataAsync(data, $productContainer, imagesShouldUpdate, function (res) {
                        $('body').trigger('product:afterProductInfoRetrieve', { data: res, container: $productContainer, type: type });
                        $.spinner().stop();
                    });
                } else {
                    $.spinner().stop();
                }
                checkColorAttribute();

                if (type === 'color') {
                    updatePreviouslyPurchasedSizeLabel(data.product);
                }
                $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer, type: type });
            },
            error: () => {
                $.spinner().stop();
            }
        }).then(function () {
            if ($('.swatch-boolean input:checked[data-iscomingsoon=true]+.notifyMe').length > 0) {
                $('.swatch-boolean input:checked[data-iscomingsoon=true]+.notifyMe').click();
            }
            if ($('.quickview-modal--tezenis').length > 0) {
                $('.quickview-modal--tezenis').find('.notifyMe').siblings().attr('disabled', true);
                $('.quickview-modal--tezenis').find('.notifyMe').removeClass('notifyMe');
            } else if ($('.choose-bonus-product-dialog .product-quickview').length > 0) {
                $('.choose-bonus-product-dialog .product-quickview').find('.notifyMe').siblings().attr('disabled', true);
                $('.choose-bonus-product-dialog .product-quickview').find('.notifyMe').removeClass('notifyMe');
            }
        });
    }
};

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
const getQuantitySelector = ($el) => {
    return $el && $('.set-items').length ?
        $($el).closest('.product-detail').find('.quantity-select') :
        $('.quantity-select');
};

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
const getQuantitySelected = ($el) => {
    return getQuantitySelector($el).val();
};

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {boolean} isChoiceOfBonusProducts - Flag wheter an attribute is a bonusProduct
 */
const processSwatchValues = (attr, $productContainer, isChoiceOfBonusProducts, colorFamily) => {
    attr.values.forEach(attrValue => {
        const $attrValue = $productContainer.find(`[data-attr="${attr.id}"] [data-attr-value="${attrValue.value}"]`);
        const $swatchAnchor = $attrValue.parent();

        if (attrValue.selected) {
            $productContainer.find('.attribute-label').text(attrValue.displayValue + ' - ' + attrValue.id);
            if ($attrValue[0]) {
                $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection`).html($attrValue[0].outerHTML);
                $attrValue.addClass('selected');
            }
            if (isChoiceOfBonusProducts) {
                $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection-color-description`).text(colorFamily + ' - ' + attrValue.displayValue + ' - ' + attrValue.id);
                if ($productContainer.find('.bonus-color-description-selected').hasClass('hidden')) {
                    $productContainer.find('.bonus-color-to-select').addClass('hidden');
                    $productContainer.find('.bonus-color-description-selected').removeClass('hidden');
                    $productContainer.find('.product-selection-label-color').addClass('hidden');
                    $productContainer.find('.product-selection-name-color').addClass('hidden');
                }
                if ($('.product-selection-label-color').css('display') == 'none') {
                    $productContainer.find('.product-selection-label-size').hide();
                    $productContainer.find('.product-selection-name-size').hide();
                }
                $productContainer.find('.product-selection-label-color').hide();
                $productContainer.find('.product-selection-name-color').hide();
            }
        } else {
            $attrValue.removeClass('selected');
        }

        if (attrValue.url) {
            $swatchAnchor.attr('data-url', attrValue.url);
        } else {
            $swatchAnchor.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable soldout');

        $attrValue.addClass((attrValue.selectable || attrValue.isSoldout) ? 'selectable' : 'unselectable');
        if (attrValue.isSoldout) {
            $attrValue.addClass('soldout');
        }
    });
};

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {boolean} isChoiceOfBonusProducts - Flag wheter an attribute is a bonusProduct
 */
const processNonSwatchValues = (attr, $productContainer, type, isChoiceOfBonusProducts) => {
    const $attr = `[data-attr="${attr.id}"]`;
    const $defaultOption = $productContainer.find(`${$attr} .select-${attr.id} option:first`);
    $defaultOption.attr('value', attr.resetUrl);

    const isCartEditModal = $productContainer.closest('.js-cart-edit-product-modal').length > 0 || $('.cart-page').length > 0;

    attr.values.forEach(attrValue => {
        const $attrValue = $productContainer.find(`${$attr} [data-attr-value="${attrValue.value}"]`);
        if (!$productContainer.hasClass('cc-completeThePromo-modal-container') && (!$productContainer.hasClass('js-product-quickview--tezenis') || isCartEditModal)) {
            $attrValue.attr('value', attrValue.variationUrl).removeAttr('disabled');
        }
        if ($productContainer.hasClass('product-quickview-bonus-product')) {
            $attrValue.attr('data-sku', attrValue.sku);
        }
        if (attrValue.selected) {
            $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection`).html(attrValue.displayValue);
            if (isChoiceOfBonusProducts) {
                $productContainer.find('.bonus-size-description-selected .attribute-label').text(attrValue.displayValue);
                if ($productContainer.find('.bonus-size-description-selected').hasClass('hidden')) {
                    $productContainer.find('.bonus-size-to-select').addClass('hidden');
                    $productContainer.find('.bonus-size-description-selected').removeClass('hidden');
                    $productContainer.find('.two-points-attribute').removeClass('hidden');
                    $productContainer.find('.product-selection-label-size').addClass('hidden');
                }
            }
        }

        if ($('#isNotifyActive').val() == "true") {
            if (!attrValue.selectable || attrValue.isComingSoon) {
                $attrValue.siblings('span').addClass('notifyMe');
            } else {
                $attrValue.siblings('span').removeClass('notifyMe');
                $('.notify-me-button-wrapper').addClass('hidden');
            }
        } else {
            if (!attrValue.selectable && Foundation.MediaQuery.atLeast('medium')) {
                $attrValue.attr('disabled', true);
                $('.notify-me-button-wrapper').removeClass('hidden');
            }
        }
        $attrValue.closest('.js-size-container').toggleClass('hide', attrValue.disabled || attrValue.sku === 0);
    });
};

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 */
const updateAttrs = (attrs, $productContainer, type, isChoiceOfBonusProducts, colorFamily) => {
    // Currently, the only attribute type that has image swatches is Color.
    const attrsWithSwatches = ['color'];

    attrs.forEach(attr => {
        if (attrsWithSwatches.indexOf(attr.attributeId) > -1) {
            processSwatchValues(attr, $productContainer, isChoiceOfBonusProducts, colorFamily);
        } else {
            processNonSwatchValues(attr, $productContainer, type, isChoiceOfBonusProducts);
        }
    });
};

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
const updateAvailability = (response, $productContainer) => {
    let availabilityValue = '';
    let availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = `<div>${response.resources.info_selectforstock}</div>`;
    } else {
        availabilityMessages.forEach(message => {
            availabilityValue += `<div>${message}</div>`;
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });

    if ($productContainer.hasClass('product-detail')) {
        if (response.product.isSoldout === true) {
            $productContainer.addClass('is-soldout');
        } else {
            $productContainer.removeClass('is-soldout');
        }
    }
};

/**
 * Generates html for promotions section
 *
 * @param {array} promotions - list of promotions
 * @return {string} - Compiled HTML
 */
const getPromotionsHtml = promotions => {
    if (!promotions) {
        return '';
    }

    let html = '';

    promotions.forEach(function (promotion) {
        html += `<div class="callout" title="${promotion.details}">${promotion.calloutMsg}</div>`;
    });

    return html;
};

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
const getAttributesHtml = (attributes) => {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(attributeGroup => {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += `<div class="attribute-values">${attribute.label}: ${attribute.value}</div>`;
            });
        }
    });

    return html;
};

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} options - Ajax response options from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
const updateOptions = (options, $productContainer) => {
    options.forEach(option => {
        const $optionEl = $productContainer.find(`.product-option[data-option-id*="${option.id}"]`);
        option.values.forEach(value => {
            const valueEl = $optionEl.find(`option[data-value-id*="${value.id}"]`);
            valueEl.val(value.url);
        });

        option.values.forEach(value => {
            const valueEl = $optionEl.find(`input[id="${value.id}"]`);
            valueEl.data('href', value.url);
            valueEl.attr('href', value.url);
        });
    });
};

const updateColorFamily = (product, $productContainer) => {
    $productContainer.find('.family-color').text(product.colorFamily + ' - ');
};

const updateScanTrustLink = (attr, $productContainer) => {
    let $productAuthenticity = $productContainer.find('.product-authenticity');
    if ($productAuthenticity.length > 0) {
        $productAuthenticity.find('.js-update-scantrustUrl').attr('href', attr.scanTrustUrlWithParams);
    }
}

/**
 * Updates the composition and care maintenance section
 * @param {Object} product - Product data
 * @param {jQuery} $container - Desktop container
 * @param {jQuery} $mobileContainer - Mobile container
 * @param {Object} svgContainer - SVG icons mapping
 */
const updateCompositionUI = (product, $container, $mobileContainer, svgContainer) => {
    if (product.partTypes && product.partTypes.length > 0 && svgContainer) {
        $container.empty();
        $mobileContainer.empty();

        const $compositionContainer = $('<div>');

        for (var k = 0; k < product.partTypes.length; k++) {
            if (k == 0) {
                var type = `${product.partTypes[k].type}: `;
                $compositionContainer.append(type);
            }
            if (k < product.partTypes.length - 1) {
                if (product.partTypes[k].type == product.partTypes[k + 1].type) {
                    var comp = `${product.partTypes[k].percentage} % ${product.partTypes[k].material}, `;
                    $compositionContainer.append(`<div class="comp-material">${comp}</div>`);
                } else {
                    var comp = `${product.partTypes[k].percentage} % ${product.partTypes[k].material}`;
                    var type = `</br>${product.partTypes[k + 1].type}: `;

                    $compositionContainer.append(`<div class="comp-material">${comp}</div>`);
                    $compositionContainer.append(type);
                }
            } else {
                var comp = `${product.partTypes[k].percentage} % ${product.partTypes[k].material} `;
                $compositionContainer.append(`<div class="comp-material">${comp}</div>`);
            }
        }

        $compositionContainer.clone().appendTo($mobileContainer);
        $compositionContainer.clone().appendTo($container);
    } else if (product.mainComposition && product.mainComposition.length > 0 && svgContainer) {
        $container.empty();
        $container.addClass('grid-x');
        $mobileContainer.empty();
        $mobileContainer.addClass('grid-x');

        const $compositionContainer = $('<div class="cell">');

        for (let k in product.mainComposition) {
            const html = `<div class="comp-material">${product.mainComposition[k].percentage} % ${product.mainComposition[k].material}</div>`;
            $compositionContainer.append($(html));
        }

        $compositionContainer.clone().appendTo($mobileContainer);
        $compositionContainer.clone().appendTo($container);
    }

    if (product.careMaintenanceCode && svgContainer) {
        let img = WashingSymbols.getWashingSymbols({ product: product }, svgContainer);

        $container.append($(img));
        $mobileContainer.append($(img));

        document.querySelectorAll('.icon-wash').forEach(el => {
            const title = el.getAttribute('title');
            if (title && !el.querySelector('.icon-wash__text')) {
                const span = document.createElement('span');
                span.className = 'icon-wash__text';
                span.textContent = title;
                el.appendChild(span);
            }
        });
    }
};

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
const handleVariantResponse = (response, $productContainer, imagesShouldUpdate = true, type) => {
    const isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    const isQuickAdd = $productContainer.hasClass('js-product-quickview--tezenis');
    let isVaraint;
    hideNotifyButton();
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, type, isChoiceOfBonusProducts, response.product.colorFamily);
        updateColorFamily(response.product, $productContainer);
        updateScanTrustLink(response, $productContainer)
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);
            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
        }
    }

    const $container = $productContainer.find('.js-composition-info');
    const $mobileContainer = $('.mobile-container').find('.js-composition-info');
    const svgContainer = $('.js-svg-urls').data();

    updateCompositionUI(response.product, $container, $mobileContainer, svgContainer);

    // Update primary images
    if (imagesShouldUpdate) {
        const primaryImageUrls = response.product.images;
        if ($productContainer.hasClass('product-quickview')) {
            $productContainer.find('.quickviewCarousel__slider').slick('destroy');
            $productContainer.find('.quickviewCarousel__slider').empty();
            $productContainer.find('.product-link-carousel').attr('href', response.product.selectedProductUrl);

            const $imageCellCarousel = $productContainer.find('.image-cell.carousel-inner');
            if ($imageCellCarousel.length) {
                if ($imageCellCarousel.hasClass('slick-initialized')) {
                    $imageCellCarousel.slick('unslick');
                }
                $imageCellCarousel.empty();

                if (primaryImageUrls.large && primaryImageUrls.large.length > 0) {
                    const slidesHtml = primaryImageUrls.large.map((img, idx) => `
                        <div class="carousel-item ${idx === 0 ? 'active' : ''}">
                            <a class="product-image" href="${response.product.selectedProductUrl}">
                                <img class="product-image carousel-img" src="${img.url}" alt="${img.alt}" itemprop="image" data-index="${idx}" loading="lazy"/>
                            </a>
                        </div>
                    `).join('');
                    $imageCellCarousel.append(slidesHtml);
                }

                const isCart = $imageCellCarousel.closest('.js-cart-edit-product-modal').length || $('.cart-page').length > 0;
                const isQuickAddModal = $productContainer.hasClass('js-mobile-completePromo') ||
                    $productContainer.hasClass('js-quick-add-modal') ||
                    $productContainer.hasClass('cc-quickAddToCart-modal-container') ||
                    $productContainer.hasClass('js-product-quickview--tezenis') ||
                    $imageCellCarousel.closest('.cc-completeThePromo-modal').length > 0;

                if (isQuickAddModal || isCart) {
                    $imageCellCarousel.slick({
                        dots: false,
                        arrows: !isCart,
                        prevArrow: mobileSlickArrowPrev,
                        nextArrow: mobileSlickArrowNext,
                        slidesToShow: 3.4,
                        slidesToScroll: 3,
                        draggable: true,
                        infinite: false,
                        swipeToSlide: true,
                        waitForAnimate: false,
                        responsive: [{
                            breakpoint: 769,
                            settings: {
                                draggable: true,
                                slidesToShow: 2.85,
                                slidesToScroll: 2.85,
                                swipeToSlide: true
                            }
                        }]
                    });
                } else {
                    $imageCellCarousel.slick({
                        arrows: false,
                        dots: true
                    });
                }
            } else {
                // If there's no carousel, update the single product-image (new secondary layout)
                const $productImage = $productContainer.find('.image-cell .product-image');
                if ($productImage.length && primaryImageUrls.small && primaryImageUrls.small.length > 0) {
                    $productImage.attr('src', primaryImageUrls.small[0].url);
                    if (primaryImageUrls.small[0].alt) {
                        $productImage.attr('alt', primaryImageUrls.small[0].alt);
                    }
                }
            }

            if ($productContainer.hasClass('js-mobile-completePromo') || $productContainer.hasClass('js-quick-add-modal')) {
                if (primaryImageUrls.large.length > 0) {
                    $productContainer.find('.carousel-img').each(function (index) {
                        const imageIndex = $(this).data('index');
                        if (primaryImageUrls.large[imageIndex]) {
                            $(this).attr('src', primaryImageUrls.large[imageIndex].url);
                        }
                    });
                }
            }

            // Also update left sidebar images
            const $sidebarImages = $('.quickviewCarousel__slider-nav');
            $sidebarImages.find('.quickviewCarousel__thumbnail').remove();

            primaryImageUrls.large.forEach((imageUrl, idx) => {
                let $carouselInner = $($('#outer').html());
                if (isChoiceOfBonusProducts) {
                    $carouselInner = $($productContainer.find('#outer').html());
                }
                $productContainer.find('.quickviewCarousel__slider').append($carouselInner);

                let $imgContainer = $carouselInner.find('img');
                $imgContainer.data('index', idx);
                $imgContainer.attr('id', null);
                $imgContainer.attr('src', imageUrl.url).removeClass('hidden');

                // Append images to left sidebar
                let imageToAppend = '<img src="' + imageUrl.url + '" alt="' + imageUrl.alt + '">';
                $sidebarImages.append('<div class="analytics-product-image quickviewCarousel__thumbnail ' + (idx === 0 ? 'active' : '') + '">' + imageToAppend + '</div>');
            });

            if (isChoiceOfBonusProducts) {
                $productContainer.find('.quickviewCarousel__slider').slick({
                    arrows: true,
                    prevArrow: $('.prev-button'),
                    nextArrow: $('.next-button'),
                    dots: false,
                    infinite: true,
                    draggable: false,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });
            } else {
                $productContainer.find('.quickviewCarousel__slider').slick({
                    arrows: true,
                    prevArrow: $('.prev-button'),
                    nextArrow: $('.next-button'),
                    dots: false,
                    infinite: true,
                    draggable: false,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {
                                dots: true
                            }
                        }
                    ]
                });
            }
        } else if ($productContainer.hasClass('product-quickview-bonus-product')) {
            $productContainer.find('.product-image').attr('src', response.product.images.small[0].url);
        } else {
            $productContainer.find('.pdpCarousel__slider').empty();
            let sliderHtml = '';
            let imageZoomHtml = '';
            let thumbZoomHtml = '';
            if ($('.cc-pdp__zoomImage__slider').hasClass('swiper-initialized')) {
                $('.cc-pdp__zoomImage__slider')[0].swiper.destroy(false);
            }
            $('.cc-pdp__zoomImage__slider .swiper-wrapper').empty();
            $('.cc-pdp__zoomImage__navThumbnails').empty();
            const $firstRow = $('.first-row').empty();
            const $remaining = $('.remaining-images').empty();
            primaryImageUrls.large.forEach((img, index) => {
                // append Primary images PDP
                var $imgContainer = $('<img>')
                    .addClass('productImageCarouselItem cc-product-image js-linkModalProductImageCarousel')
                    .attr('src', img.url)
                    .attr('alt', img.alt)
                    .attr('width', 1200)
                    .attr('height', 800)
                    .attr('data-index', index);

                if (index < 2) {
                    $firstRow.append($imgContainer);
                } else {
                    $remaining.append($imgContainer);
                }

                if (img.resizedUrls) {
                    var resizedUrls = '';
                    for (var i = 0; i < img.resizedUrls.length; i++) {
                        resizedUrls += img.resizedUrls[i] + ' ' + img.sizes[i].scaleWidth + 'w,';
                    }
                    resizedUrls = resizedUrls.substring(0, resizedUrls.length - 1);
                    $imgContainer.attr('srcset', resizedUrls);
                }
                $imgContainer.attr('data-index', index);

                $imgContainer = $productContainer.find('.primary-images').find(`img[data-index="${index}"]`);
                $imgContainer.attr('src', img.url).removeClass('hidden');

                sliderHtml += `<div class="swiper-slide" data-index="${index}"></div>`;
                imageZoomHtml += `<div class="cc-pdp__zoomImage__item swiper-slide cc-pdp__zoomImage__initialScale"><div class="swiper-zoom-container"><img class="zoom" src="${img.url}" alt="${img.alt}" srcset="${resizedUrls}" data-index="${index}" loading="lazy"/></div></div>`;
                thumbZoomHtml += `<div class="cc-pdp__zoomImage__itemThumbnails"><img class="cc-pdp__zoomImage__thumbnail ${index === 0 ? 'active' : ''}" src="${img.url}" alt="${img.alt}" srcset="${resizedUrls}" data-index="${index}" loading="lazy"/></div>`;
            });

            $('.carousel-inner .slider-pos').empty().append(sliderHtml);
            $('.cc-pdp__zoomImage__slider .swiper-wrapper').html(imageZoomHtml);
            $('.cc-pdp__zoomImage__navThumbnails').html(thumbZoomHtml);

            if (Foundation.MediaQuery.is('small only')) {
                // Update carousel
                const swiperEl = document.querySelector('.js-pdpCarousel');
                if (swiperEl && swiperEl.swiper) {
                    const swiper = swiperEl.swiper;
                    swiper.removeAllSlides();
                    primaryImageUrls.large.forEach(img => {
                        swiper.appendSlide(
                            `<div class="swiper-slide"><img src="${img.url}" alt="${img.alt}"></div>`
                        );
                    });
                }
            }
        }
    }

    // Update pricing
    if (!isChoiceOfBonusProducts && response.product.price && !isQuickAdd) {
        const $priceSelector = $('.prices .price', $productContainer).length ?
            $('.prices .price', $productContainer) :
            $('.prices .price');
        const priceInfoSelector = '.price-info';
        const $oldPriceInfoSelector = $('.js-oldPriceInfo');
        const $regularPriceInfoDiscountSelector = $('.js-priceInfo-discountValue');
        const $oldPriceInfoDiscountSelector = $('.js-oldPriceInfo-discountValue');
        const $priceInfoSelector = $(priceInfoSelector, $productContainer).length ?
            $(priceInfoSelector, $productContainer) :
            $(priceInfoSelector);
        $priceSelector.replaceWith(response.product.price.html);
        const isRegularOmnibusCountry = $oldPriceInfoSelector.closest('.js-omnibusStack').data('omnibuscountry');
        if (response.product.doubleCurrency && response.product.doubleCurrency.html) {
            const $doubleCurrencyContainer = $('#descriptionSidebar  .price-second-currency', $productContainer);
            const innerContent = $(response.product.doubleCurrency.html).html();
            $doubleCurrencyContainer.html(innerContent);
        }
        if (response.product.price.sales.formattedPriceInfo) {
            $priceInfoSelector.parent().show();
            $priceInfoSelector.parent().parent().show();
            if (isRegularOmnibusCountry && response.product.price.list) {
                $oldPriceInfoSelector.parent().show();
                $oldPriceInfoSelector.html(response.product.price.list.formatted);
                $priceSelector.find('.js-percentage').addClass('cc-hidePercentage');
            }
            $priceInfoSelector.html(response.product.price.sales.formattedPriceInfo);
            $regularPriceInfoDiscountSelector.html(response.product.price.discountValue + '%');
            if (response.product.price.discountValueOmnibus) {
                $oldPriceInfoDiscountSelector.html(response.product.price.discountValueOmnibus + '%');
            }
        } else {
            $priceInfoSelector.parent().hide();
            $priceInfoSelector.parent().parent().hide();
            $oldPriceInfoSelector.parent().hide();
            $priceInfoSelector.html('');
            $priceSelector.find('.js-percentage').removeClass('cc-hidePercentage');
        }
        $productContainer.find('.js-discount-msg, .js-discount-value-percentage').addClass('hidden');
        $productContainer.find('.js-promo-msg').addClass('hidden');

        if (response.product.price.list !== null) {
            $('.size-selected-on-sale').removeClass('hide');
        } else {
            $('.size-selected-on-sale').addClass('hide');
        }

        if (response.product.price.discountValue) {
            $productContainer.find('.js-discount-msg, .js-discount-value-percentage').html(response.product.price.discountValue + '%').removeClass('hidden hide');
            if (response.product.price.sales.formattedPriceInfo) {
                $productContainer.find('.price.price--tezenis .sales .value .onsale').eq(0).before('<span class="price price--tezenis sales text-primary discount-value-percentage"><span>(' + response.product.price.discountValue + '%)</span></span>');
                if (isRegularOmnibusCountry) {
                    $productContainer.find('.js-percentage').addClass('cc-hidePercentage');
                }
            } else {
                $productContainer.find('.js-percentage').removeClass('cc-hidePercentage');
            }
        }
        if (response.product.promotions && response.product.promotions.length > 0) {
            $productContainer.find('.js-promo-msg').html(response.product.promotions[0].calloutMsg).removeClass('hidden');
        }
    }

    // Update promotions
    $('.promotions').empty().html(getPromotionsHtml(response.product.promotions));

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        const $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product,
            $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));

    // DPM (PDP) update
    $productContainer.find('.product-dpm1').addClass('hidden');
    $productContainer.find('.product-dpm2').addClass('hidden');
    $productContainer.find('.product-dpm3').addClass('hidden');
    $productContainer.find('.product-dpm4').addClass('hidden');
    $productContainer.find('.product-dpmc').addClass('hidden');
    if (response.product.dpm2 != "0") {
        if (response.product.dpm2 == "C") {
            let target_dpm = ".product-dpmc";
            $productContainer.find(target_dpm).removeClass('hidden');
        } else {
            let target_dpm = ".product-dpm" + response.product.dpm2;
            $productContainer.find(target_dpm).removeClass('hidden');
        }
    }
};

const _setupBonusProductsEventListeners = () => {
    const enableBonusProductSelection = () => {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product').data('pid', pid);
        });
    };

    const enableAddAfterBonusColorSelection = () => {
        $('body').on('change', '.bonus-product .choice-of-bonus-product,.bonus-product.choose-bonus-product-dialog', function () {
            if ($(this).find('.js-panel[data-attr="color"] .swatch-value').length === 0 ||
                $(this).find('.js-panel[data-attr="color"] .swatch-value.selected').length > 0) {
                $(this).find('.add-bonus-products').prop('disabled', false).removeClass('disabled');
            } else {
                $(this).find('.add-bonus-products').prop('disabled', true);
            }
        });
        $('body').on('click touchstart', '.bonus-product-item .color-variation', function () {
            var bpi = $(this).parents('.bonus-product-item');

            if (bpi.length > 0) {
                var openers = $(bpi).find('.js-panel-opener-free-gift');
                if (openers.length > 1) {
                    $(openers.eq(1)).addClass('js-panel-opener');
                }

                if ($(bpi).find('.js-panel[data-attr="size"] input[type="radio"]').length === 0
                    || $(bpi).find('.js-panel[data-attr="size"] input[type="radio"]:checked').length) {
                    $(bpi).find('.add-bonus-products').removeAttr('disabled');
                } else {
                    $(bpi).find('.add-bonus-products').prop('disabled', true);
                }
            }
        });
    };

    enableBonusProductSelection();
    enableAddAfterBonusColorSelection();
};

const updateProductVariationDataAsync = (response, $productContainer, imagesShouldUpdate, completion) => {
    // Update Wishlist button
    if ($('.product-detail-keeper').length) {
        var pid = getPID(response.product);
        try {
            $($productContainer).find('.product-set').attr('data-pid', pid);
        } catch (e) {
        }

        $('.product-detail-keeper').attr('data-variant-pid', encodeURIComponent(pid));

        let url = $('.product-detail-keeper').data('variation-info');
        let encodedUrl = url.replace('PID_PLACEHOLDER', encodeURIComponent(pid));

        $.ajax({
            url: encodedUrl,
            method: 'GET',
            success: res => {
                completion(res);
                updateWishList(res, $productContainer);
                updateComingSoon(res, $productContainer);
                updateSoldOut(res, $productContainer);
                if (imagesShouldUpdate && $('.page').data('action') === 'Cart-Show') {
                    $('.product-quickview .product-image:not(.carousel-img)').attr('src', res.product.images.small[0].url);
                } else if (imagesShouldUpdate && $('.page').data('action') !== 'Cart-Show') {
                    updateProductDetailSlider(res, $productContainer);
                    onColorChangeUpdatePromoLabel(res);
                }
            },
            error: () => {
                completion();
            }
        });
    } else {
        completion();
    }
};

const onColorChangeUpdatePromoLabel = (res) => {
    if (res.action === 'Product-GetVariantData') {
        if (res.product.customPromoLabelBody) {
            $('.js-promo-label').removeClass('hidden');
            $('.js-promo-label').html(res.product.customPromoLabelBody);
            generatePromoAnimatedStrip();
        } else {
            $('.js-promo-label').empty();
        }
    }
};

const updateWishList = (response, $productContainer) => {
    if (response.product.isInWishlist) {
        $productContainer.find('.add-to-wish-list').addClass('added');
        $productContainer.find('.add-to-wish-list').removeClass('button-primary');
    } else {
        $productContainer.find('.add-to-wish-list').removeClass('added');
        $productContainer.find('.add-to-wish-list').addClass('button-primary');
    }
};

const updateComingSoon = (response, $productContainer) => {
    if (response.product.comingSoon) {
        $('.comingSoonLabel-pdp').removeClass('hidden');
        $('.pdp.marketing-messages').addClass('hidden');
        $('.coming-soon-banner').removeClass('hide');
    } else {
        $('.comingSoonLabel-pdp').addClass('hidden');
        $('.pdp.marketing-messages').removeClass('hidden');
        $('.coming-soon-banner').addClass('hide');
    }
};

const updateSoldOut = (response, $productContainer) => {
    if (response.product.isSoldout) {
        $('.js-sold-out-msg').removeClass('hidden');
        $('.pdp.marketing-messages').addClass('hidden');
    } else {
        $('.js-sold-out-msg').addClass('hidden');
        $('.pdp.marketing-messages').removeClass('hidden');
    }
};

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
const updateQuantities = (quantities, $productContainer) => {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        const optionsHtml = quantities.map(quantity => {
            const selected = quantity.selected ? 'selected' : '';
            return `<option value="${quantity.value}"  data-url="${quantity.url}" ${selected}>${quantity.value}</option>`;
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
};

const updatePreviouslyPurchasedSizeLabel = (product) => {
    $('.js-orderAgain-productDetails__label').data('pid', product.id).attr('data-pid', product.id);
    $('body').trigger('orderAgain:previouslyPurchasedSizeUpdate');
};

const handleStockIcon = (parentLabelElement, value) => {
    let radioLabel = $(parentLabelElement).find('.radio-label');
    $(radioLabel).find('i').remove();

    if (value.isLowStockSize || value.allocation <= 0) {
        if (value.isLowStockSize) {
            $(radioLabel).append($('.js-icon-container-time').first().children().clone(true));
        } else {
            $(radioLabel).append($('.js-icon-container-notifications').first().children().clone(true));
        }
    }
};

const createMissingOutOfStockLabel = (parentLabelElement) => {
    let span = document.createElement('span');
    $(span).addClass('tooltip-stock-wrapper');

    let childSpan = document.createElement('span');
    $(childSpan).addClass('tooltip-stock-text');

    let childChildSpan = document.createElement('span');
    $(childSpan).append(childChildSpan);

    $(span).append(childSpan).insertAfter(parentLabelElement);
};

const getTooltipWrapper = (parentLabelElement) => {
    let tooltipStockWrapper = $(parentLabelElement).siblings('.tooltip-stock-wrapper');
    if (!$(tooltipStockWrapper).length) {
        createMissingOutOfStockLabel(parentLabelElement);
        tooltipStockWrapper = $(parentLabelElement).siblings('.tooltip-stock-wrapper');
    }
    return $(tooltipStockWrapper);
};

const handleSizeAvailabilityTooltips = (variationAttributes) => {
    if (!$('.tooltip-stock-wrapper').length) {
        return;
    }

    let lowInstockText = $('[data-lowinstock-text]').data('lowinstock-text');
    let notifyMeText = $('[data-notifyme-text]').data('notifyme-text');

    for (let attr of variationAttributes) {
        if (attr.attributeId === 'size' && Foundation.MediaQuery.atLeast('medium')) {
            for (let val of attr.values) {
                let selector = val.id.toLowerCase().split('').join('_');
                if (isNaN(parseInt(selector[0]))) {
                    selector = '_' + selector;
                }
                if (/[0-9]+-[0-9]+/gm.test(val.id)) {
                    selector = val.id.toLowerCase().replace('-', '__002d');
                }
                let label = $('label[for="' + selector + '"]');
                let tooltipStockWrapper = getTooltipWrapper(label);

                handleStockIcon(label, val);

                if (val.isLowStockSize || val.allocation <= 0) {
                    $(tooltipStockWrapper).removeClass('tooltip-hidden');
                    const tooltipText = val.isLowStockSize ? lowInstockText : notifyMeText;
                    $(tooltipStockWrapper).find('.tooltip-stock-text').find('span').text(tooltipText);
                } else {
                    $(tooltipStockWrapper).addClass('tooltip-hidden');
                }
            }
        }
    }
};

const handleLowInStock = (variationAttributes, $productContainer) => {
    for (let attr of variationAttributes) {
        if (attr.attributeId === 'size') {
            const selectedSize = attr.values.find(val => val.selected);

            if (!selectedSize) return;

            const allocation = selectedSize.allocation || 0;
            const isLowStock = selectedSize.isLowStockSize || allocation < 3;
            const isOutOfStock = allocation === 0;
            const isSoldOut = selectedSize.isSoldOut === true;

            const $lowStockError = $productContainer.find('.low-in-stock-error');
            const $notInStockError = $productContainer.find('.out-of-stock-error');
            const $soldOutError = $productContainer.find('.out-of-stock-error');
            const $notifyBlock = $productContainer.find('.notify-block');

            $('.pdp-error').addClass('hidden');

            if (isSoldOut) {
                $soldOutError.removeClass('hidden');
                $notifyBlock.removeClass('hidden');
            } else if (isOutOfStock) {
                $notInStockError.removeClass('hidden');
                $notifyBlock.removeClass('hidden');
            } else if (isLowStock) {
                $lowStockError.removeClass('hidden');
                $notifyBlock.removeClass('hidden');
            }
             
            return;
        }
    }
};

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
const getAddToCartUrl = () => {
    return $('.add-to-cart-url').val();
};

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
const parseHtml = html => {
    var $html = $('<div>').append($.parseHTML(html));

    var body = '';
    let $results = $html.find('.choice-of-bonus-product');
    for (let i = 0; i < $results.length; i++) {
        body += $results[i].outerHTML;
    }
    var footer = $html.find('.modal-footer').children().html();

    return {
        body: body,
        footer: footer
    };
};

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
const chooseBonusProducts = data => {
    // $('.modal-body').spinner().start();
    const bonusUrl = data.bonusChoiceRuleBased ? data.showProductsUrlRuleBased : data.showProductsUrlListBased;

    var htmlString = `
        <div class="modal-content bonus-product choose-bonus-product-dialog"
            id="chooseBonusProductModal"
            data-total-qty="${data.maxBonusItems}"
            data-UUID="${data.uuid}"
            data-pliUUID="${data.pliUUID}"
            data-addToCartUrl="${data.addToCartUrl}"
            data-pageStart="0"
            data-pageSize="${data.pageSize}"
            data-moreURL="${data.showProductsUrlRuleBased}"
            data-bonusChoiceRuleBased="${data.bonusChoiceRuleBased}">
            <div class="modal-header">
                <button type="button" class="js-confirm-bonus-products-back cc-back-custom hidden"><span aria-hidden="true"></span></button>
                <h4 class="">${data.labels.selectprods}</h4>
                <button type="button" class="close close-custom" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"></span></button>
            </div>
            <div class="modal-body"></div>
            <div class="modal-footer"></div>
            <div class="col-sm-12 text-center modal-footer-button">
                <button class="button btn-outline-primary col-12 col-sm-4 js-confirm-bonus-products" disabled>
                ${data.labels.confirm}
                </button>
            </div>
        </div>`;

    const modalContent = document.createElement('div');
    modalContent.innerHTML = htmlString;

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: rsp => {
            var parsedHtml = parseHtml(rsp.renderedTemplate);
            modalContent.querySelector('.modal-body').innerHTML = parsedHtml.body !== '' ? parsedHtml.body : rsp.renderedTemplate;
            modalContent.querySelector('.modal-footer').innerHTML = parsedHtml.footer ? parsedHtml.footer : '';
            if (parsedHtml.body === '') {
                modalContent.querySelector('.modal-footer-button').innerHTML = '';
            }
            const onPopupClose = () => {
                if (data.isTriggeredByCoupon) {
                    window.location.reload();
                }
            };
            const modal = newModalFromString(modalContent, false, ['bonus-product-modal'], null, onPopupClose);

            $('.bonus-product-modal').addClass('bonus-modal--tezenis');
            $(modal.modalBox).addClass('rightModalAttribute');

            if ($('.page').data('action') === 'Cart-Show') {
                $('.bonus-product-item .quickviewCarousel__slider').slick({
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                });

                modal.open();
            } else {
                setTimeout(function () {
                    modal.open();
                    if ($('.product-quickview-bonus-product').length === 1 && $('.product-quickview-bonus-product').hasClass('product-master')) {
                        $('.product-quickview-bonus-product').find('.slider-values-container .color-variation .selectable').eq(0).trigger('click');
                    }
                    $('.bonus-product-item .quickviewCarousel__slider').slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false
                    });
                }, 2000);
            }

            var bonusProductItems = $('.bonus-product-item');
            for (var i = 0; i < bonusProductItems.length; i++) {
                var bpi = bonusProductItems.eq(i);
                var openers = $(bpi).find('.js-panel-opener-free-gift');
                var colorLabel = $(bpi).find('.product-selection-label-color');
                if (colorLabel.length > 0 && openers.length > 1 && !$(colorLabel).hasClass('hidden')) {
                    $(openers.eq(1)).removeClass('js-panel-opener');
                }
            }
            bonusProductModal = modal;
            $(modal.modalBox)
                .find('.close')
                .on('click', function (e) {
                    modal.close();
                });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
            _setupBonusProductsEventListeners();
            $('body').trigger('bonusProduct:quickviewOpen', { products: rsp.products, container: $(modal.modalBox).find('#chooseBonusProductModal') });
            $('.js-confirm-bonus-products').on('click', function (e) {
                e.preventDefault();
                let selectedBonusProductId = 'bonus_product_' + $('input[name="bonus-product-choice"]:checked').val();
                let $selectedBonusProduct = $('[id="' + selectedBonusProductId + '"]');

                if ($selectedBonusProduct.find('.slider-values-container .color-variation .selected').length > 0 &&
                    $selectedBonusProduct.find('.js-accordion-size-wrapper .sizes-container input:checked').length > 0) {
                    $selectedBonusProduct.find('.add-bonus-products').trigger('click');
                } else {
                    if ($selectedBonusProduct.find('.slider-values-container .color-variation .selected').length === 0) {
                        $selectedBonusProduct.find('.slider-values-container .color-variation .selectable').eq(0).trigger('click');
                    }
                    $('.bonus-product-item .product-quickview').hide();
                    $('.js-confirm-bonus-products').closest('.modal-footer-button').hide();
                    $selectedBonusProduct.removeClass('hidden');
                    $('.js-confirm-bonus-products-back').removeClass('hidden');
                    if ($selectedBonusProduct.hasClass('product-master')) {
                        $selectedBonusProduct.find('.add-bonus-products').addClass('disabled');
                    }
                }
                $('body').trigger('bonusProduct:productSelected', { container: $selectedBonusProduct });
            });
            $('.js-confirm-bonus-products-back').on('click', function (e) {
                let selectedBonusProductId = 'bonus_product_' + $('input[name="bonus-product-choice"]:checked').val();
                let $selectedBonusProduct = $('[id="' + selectedBonusProductId + '"]');
                $('.bonus-product-item .product-quickview').show();
                $('.js-confirm-bonus-products').closest('.modal-footer-button').show();
                $selectedBonusProduct.addClass('hidden');
                $('.js-confirm-bonus-products-back').addClass('hidden');
                $('body').trigger('bonusProduct:quickviewOpen', { products: rsp.products, container: $(modal.modalBox).find('#chooseBonusProductModal') });
            });
            $('.choose-bonus-product-dialog .bonus-product-item .bonus-product-radio').on('change', function (e) {
                $('.js-confirm-bonus-products').removeAttr('disabled');
            });
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

// Generates a PID based on the current selected attributes
const getPID = (product) => {
    if (typeof product === 'string') {
        return product.trim();
    }

    // size and color have already been selected. In this case, the variation
    // group is built with the style of the product, 'color' and the selected
    // color variation
    if (product.productType === 'variant') {
        let sku = product.id;
        return sku;
    } else if (product.productType === 'variationGroup') {
        // in this case the user only chose the color, and not the size
        let pid = product.id.split('_')[0].trim();

        let selectedVariation;

        for (let k in product.variationAttributes) {
            const variationAttribute = product.variationAttributes[k];
            if (variationAttribute.attributeId === 'color') {
                for (let j in variationAttribute.values) {
                    if (variationAttribute.values[j].selected === true) {
                        selectedVariation = variationAttribute.values[j].value;
                        break;
                    }
                }
            }
            if (selectedVariation !== undefined) {
                break;
            }
        }

        return pid + '_color_' + selectedVariation;
    }

    return '';
};

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
const handlePostCartAdd = response => {
    // show add to cart toast
    if (response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0 &&
        !response.newBonusDiscountLineItem.newBonusDiscountLineItemAutomaticallyAdded) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (response.error) {
            return;
        }

        if ($('.add-to-cart-messages').length === 0) {
            $('.minicart').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }
    }
    $('body').trigger('count:update', response);

    const cookies = document.cookie.split(';');
    let cookieSizebaySessionId = null;
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith('SIZEBAY_SESSION_ID_V4')) {
            cookieSizebaySessionId = cookie.substring('SIZEBAY_SESSION_ID_V4='.length).replaceAll('"', '');
            break;
        }
    };

    if (cookieSizebaySessionId === null) {
        let urlSessionId = document.querySelector('#sizebayAddProduct').getAttribute('data-sizebaysessionidurl');
        fetch(urlSessionId)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                createCookie('SIZEBAY_SESSION_ID_V4', data);
                callSizebayAPI(data);
            });
    } else {
        callSizebayAPI(cookieSizebaySessionId);
    }
};

function callSizebayAPI(data) {
    let permaProductId = '';

    if ($('.page[data-action="Product-Show"]').length > 0) {
        permaProductId = document.querySelector('.analytics.product.hidden').getAttribute('data-item_id');
        let permaURL = document.querySelector('#sizebayAddProduct').getAttribute('data-referrer-sizebay-link') + permaProductId;
        let url = document.querySelector('#sizebayAddProduct').getAttribute('data-sizebay-link') + '=' + data;

        let payload = JSON.stringify({
            "products": [
                {
                    "permalink": permaURL
                }
            ],
            "tenantId": 4252
        });

        let device = $('.pdpCarousel__slider-nav').css('display') === 'none' ? 'mobile' : 'desktop';
        let referrerURL = new URL(window.location.href);
        try {
            fetch(url, {
                method: 'POST',
                body: payload,
                referrerPolicy: "origin-when-cross-origin",
                headers: {
                    "content-type": "application/json",
                    accept: "application/json",
                    tenant_id: '4252',
                    device: device,
                    referer: referrerURL.hostname
                }
            });
        } catch (error) {
            console.error("Error: ", error);
        }
    }
}

export function handleColorVariationClick(e, modalContainer) {
    e.preventDefault();

    var $productContainer = $(e.currentTarget).closest('.product-detail.product-quickview');
    var selectedValueUrl = $(e.currentTarget).attr('href');

    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        success: function (data) {
            var variationValues = data.product.variationAttributes[1].values;

            changeSizeModal(variationValues, $productContainer);
            handleVariantResponse(data, $productContainer);
            handleVariationUrlsSelectNotifyModal(variationValues);
            handleVariationComingSoonNotifyModal(variationValues);
            updateOptions(data.product.options, $productContainer);
            updateQuantities(data.product.quantities, $productContainer);

            updateProductVariationDataAsync(data, $productContainer, true, function () {
                $.spinner().stop();
            });

            checkColorAttribute();

            var $addToCartBtn = $('.js-completeThePromo-modal-addToCart-btn', modalContainer);
            if (!$addToCartBtn.hasClass('disabled')) {
                $addToCartBtn.addClass('disabled');
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}
/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
const handlePostCartAddCompletePromo = response => {
    $('body').trigger('count:updateCompletePromo', response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0 &&
        !response.newBonusDiscountLineItem.newBonusDiscountLineItemAutomaticallyAdded) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (response.error) {
            return;
        }

        if ($('.add-to-cart-messages').length === 0) {
            $('.minicart').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }
    }
};

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
const getChildProducts = () => {
    var childProducts = [];
    $('.bundle-item').each((i, el) => {
        childProducts.push({
            pid: $(el).find('.product-id').text(),
            quantity: parseInt($(el).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
};

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
const getOptions = $productContainer => {
    const options = $productContainer
        .find('.product-option')
        .map(() => {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find(`option[value="${urlValue}"]`).data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
};

/**
 * Generates html for quick add form
 *
 * @param {string} pid - pid used to get variation
 * @param {string} url - url of the Controller
 * @return Compiled HTML
 */
const showQuickAddItems = (pid, url) => {
    if ($('.js-modal-quick-add-size-quantity').attr('data-pid') === pid) {
        $('.js-modal-quick-add-size-quantity').removeClass('hidden');
        return;
    }
    $('.select-size-quick-add-container').addClass('hidden').empty();
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        data: {
            pid: pid
        },
        success: function (data) {
            // Desktop
            if (Foundation.MediaQuery.atLeast('medium') || $('.page').data('action') === 'Cart-Show') {
                // Append data and show window
                const $selectSizeContainer = $('.select-size-quick-add-container[data-pid="' + pid + '"]');
                $selectSizeContainer.append(data).removeClass('hidden');

                $.spinner().stop();

                // If click outside close select size
                $('body').on('click touchstart', '.page, .container-complete-your-promo-modal', e => {
                    if ($(e.target).closest('.select-size-quick-add-container').length === 0) {
                        $('.select-size-quick-add-container').addClass('hidden').empty();
                    }
                });

                // On select size
                $selectSizeContainer.on('click', 'input', e => {
                    e.preventDefault();

                    const selectedValue = $(e.currentTarget).attr('value');
                    if (selectedValue === 'null') {
                        return;
                    }

                    // Handle size click
                    let $productContainer = $(e.currentTarget).closest('.quickSizeModal');
                    if ($productContainer && $productContainer.length > 0) {
                        attributeSelectQuickAdd(selectedValue, $productContainer, '_', false);
                        $productContainer.find('.add-to-cart-quick-add').attr('data-size-available', true);
                    }
                });
            } else { // Mobile
                const htmlContent = data;
                // create and open confirmation modal
                const modal = newModalFromString(htmlContent, false);
                $(modal.modalBox).addClass('quickselect-size-modal');
                modal.open();
                modal.setContent(document.querySelector('.js-modal-quick-add-size-quantity').innerHTML);
                // $('.add-to-cart-quick-add[data-pid="' + pid + '"').attr('data-size-selected', true);
                $.spinner().stop();
                $(modal.modalBox).on('click', '.modal__closeIcon', (e) => {
                    modal.close();
                    modal.destroy();
                });
                $(modal.modalBox).on('click', 'input', e => {
                    e.preventDefault();
                    const selectedValue = $(e.currentTarget).attr('value');
                    if (selectedValue === 'null') {
                        return;
                    }
                    let $productContainer = $(e.currentTarget).closest('.quickSizeModal');
                    if ($productContainer && $productContainer.length > 0) {
                        attributeSelectQuickAdd(selectedValue, $productContainer, '_', false);
                        $productContainer.find('.add-to-cart-quick-add').attr('data-size-available', true);
                    }
                });
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
};

/**
 * updates the product view when a product attribute of quickAdd is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} type - type of filter selected
 */
const attributeSelectQuickAdd = (selectedValueUrl, $productContainer, type = '_', imagesShouldUpdate = true) => {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: data => {
                handleVariantResponseQuickAdd(data, $productContainer, imagesShouldUpdate);
                $productContainer.attr('data-pid', data.product.id);

                // For mobile
                if (!Foundation.MediaQuery.atLeast('medium')) {
                    var oldPid = $productContainer.find('.add-to-cart-quick-add').attr('data-pid');
                    $('.product-detail-quick-add button.add-to-cart-quick-add[data-pid="' + oldPid + '"').attr('data-pid', data.product.id);
                }

                $productContainer.find('.add-to-cart-quick-add').attr('data-pid', data.product.id);
                if ($productContainer.hasClass('quickSizeModal')) {
                    $productContainer.find('.add-to-cart-quick-add').attr('data-size-selected', true);
                    $productContainer.find('.add-to-cart-quick-add').click();
                    // Close select size (mobile or desktop)
                    $('.select-size-quick-add-container').addClass('hidden').empty();
                    $('.js-modal-quick-add-size-quantity').addClass('hidden');
                    $('.closeQuickSize').click();
                }
                $.spinner().stop();
            },
            error: () => {
                $.spinner().stop();
            }
        });
    }
};

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
const handleVariantResponseQuickAdd = (response, $productContainer, imagesShouldUpdate = true) => {
    $('body').trigger('product:updateAddToCartQuickAdd', {
        product: response.product,
        $productContainer: $productContainer
    }).trigger('product:statusUpdate', response.product);

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
};

/**
 * Check selected color attribute to toggle color name in case of sales
 */

const changeSizeModal = (response, $productContainer) => {
    $('.js-change-size').removeClass('selected');
    $('.js-completeThePromo-modal-size-value').removeClass('hidden');
    $('.js-completeThePromo-modal-size-selected').addClass('hidden');
    response.forEach(function (element) {
        var $input = $productContainer.find('input[data-attr-value=' + element.id + ']');
        var $label = $input.length ? $input.closest('label') : $productContainer.find('label[for=' + element.id + ']');

        $input.prop('disabled', false);
        $input.attr('data-url', element.variationUrl);
        $input.attr('value', element.variationUrl);
        $label.attr('data-sku-value', element.sku).addClass('js-change-size');
        var notifyMe = $('#isNotifyActiveMobile').val();
        var $radioLabel = $input.parent().find('.radio-label');
        $radioLabel.removeClass('lowInStock').removeClass('notifyMe').removeClass('outofstock-tag').find('.notify-icon').addClass('hidden').find('.alertNotify').addClass('hidden');
        if (element.allocation === 0) {
            $label.attr('data-sku-value', element.sku).removeClass('js-change-size');
            $input.prop('disabled', true);
            $radioLabel.addClass('outofstock-tag').find('.notify-icon').removeClass('hidden').find('.alertNotify').addClass('hidden');
            if (notifyMe) {
                $radioLabel.addClass('notifyMe');
            }
        } else if (element.allocation < 3) {
            $radioLabel.addClass('lowInStock').find('.notify-icon').addClass('hidden').find('.alertNotify').removeClass('hidden');
        }
    });
};
const checkColorAttribute = () => {
    if ($('[data-attr="color"] .selected').closest('.color-on-sale').length > 0) {
        $('.default-code-color').find('.family-color, .attribute-label').hide();
        $('.desc-sale').find('.family-color, .attribute-label').show();
    } else {
        $('.default-code-color').find('.family-color, .attribute-label').show();
        $('.desc-sale').find('.family-color, .attribute-label').hide();
    }
    /**
     * Fix selected color label show for pdp restyle
     */
    if ($('.page').data('action') === 'Product-Show') {
        $('.default-code-color').find('.family-color, .attribute-label').show();
    }
};

/**
 * Hide buttons used to notify coming-soon and back-in-stock
 */
const hideNotifyButton = () => {
    $('.notify-block').addClass('hidden');
    $('.attribute-container.quantity.hide-for-small-only').removeClass('hidden');
    $('.attribute-container.quantity.show-for-small-only').removeClass('hidden');
    $('.add-to-cart.button.large-10').removeClass('hidden');
    $('.tezenis--fond-yoursize-link.hide-for-large').removeClass('hidden');
    $('.titleNotComingSoon').addClass('hidden');
    $('.subTitleNotComingSoon').addClass('hidden');
    $('.red').addClass('hidden');
    $('.clicked-size').removeClass('clicked-size');
};

const handleVariationUrlsSelectNotifyModal = (variationUrls) => {
    variationUrls.forEach(function (element) {
        if ((element.id).indexOf('/') != -1) {
            let cleanId = (element.id).split('/')[0] + '\\/' + (element.id).split('/')[1];
            $('input[data-attr-value=' + cleanId + ']').attr('data-url', element.variationUrl);
        } else {
            $('input[data-attr-value=' + element.id + ']').attr('data-url', element.variationUrl);
        }
    });
};

const handleVariationComingSoonNotifyModal = (comingSoons) => {
    comingSoons.forEach(function (element) {
        if ((element.id).indexOf('/') != -1) {
            let cleanId = (element.id).split('/')[0] + '\\/' + (element.id).split('/')[1];
            $('input[data-attr-value=' + cleanId + ']').attr('data-isComingSoon', element.isComingSoon);
        } else {
            $('input[data-attr-value=' + element.id + ']').attr('data-isComingSoon', element.isComingSoon);
        }
    });
};

const getProductVariationGroup = (product) => {
    if (typeof product === 'string') {
        return product.trim();
    }

    // size and color have already been selected. In this case, the variation
    // group is built with the style of the product, 'color' and the selected
    // color variation
    let pid = '';
    if (product.productType === 'variant') {
        pid = product.id.split(' ')[0].trim();
    } else if (product.productType === 'variationGroup') {
        // in this case the user only chose the color, and not the size
        pid = product.id.split('_')[0].trim();
    }
    let selectedVariation;

    for (let k in product.variationAttributes) {
        const variationAttribute = product.variationAttributes[k];
        if (variationAttribute.attributeId === 'color') {
            for (let j in variationAttribute.values) {
                if (variationAttribute.values[j].selected === true) {
                    selectedVariation = variationAttribute.values[j].value;
                    break;
                }
            }
        }
        if (selectedVariation !== undefined) {
            break;
        }
    }

    return pid + '_color_' + selectedVariation;
};

const handleVariationCustomization = (variationUrls, variation) => {
    var pid = getProductVariationGroup(variationUrls);
    $('.js-createPersonalizationOpenSize').data('pid', pid).attr('data-pid', pid);
    $('.js-createPersonalization').data('pid', pid).attr('data-pid', pid);
    if (!$('.js-createPersonalizationOpenSize').parent().hasClass('d-none')) {
        $('.js-createPersonalizationOpenSize').parent().addClass('d-none');
    }
    if (variation && typeof variation.isPersonalizedVal !== 'undefined') {
        $('.js-createPersonalizationOpenSize').parent().removeClass('d-none');
    }
};

function animationOnStoreLocator() {
    $('body').on('focusin', '.localities-input-wrapper', (e) => {
        $(e.currentTarget).closest('.form-item').find('.form-control-label').css('opacity', '1');
    });
}

function createStoreDetailsModal() {
    $('body').on('clickonStoreMarkerInfo', (e, store) => {
        const modal = newModalFromSelector('find-in-store-details', false, ['cc-pdp__findInStoreModal']);
        modal.open();

        $('.cc-pdp__findInStoreModal__body').attr('data-store-name', store.formattedName);
        $('.js-findInStoreName').html(store.formattedName);
        $('.js-indInStoreDistance').html(store.distance);
        $('.js-findInStoreAddress').html(store.address1 + '<br/>' + store.postalCode + ' ' + store.city);
        $('.js-linkToPage').attr('href', store.storeUrl);

        let googleLink = 'https://maps.google.com/?daddr=' + store.latitude + ',' + store.longitude;
        $('.js-findInStoreLink').attr('href', googleLink);

        let phoneLink = 'tel:' + store.phone.replace('-', '');
        $('.js-findInStorePhone').html(store.phone).attr('href', phoneLink);

        let hoursHtml = '<ul class="cc-pdp__findInStoreModal__storeHoursList">';
        for (let i = 0; i < store.storeHours.length; i++) {
            let storeHours = store.storeHours[i];
            hoursHtml += `
                <li data-name="${storeHours.name}" data-phases="${storeHours.hasPhases ? storeHours.phases : false}" data-first-phase="${storeHours.firstPhase}">
                    ${storeHours.label} ${storeHours.phases}
                </li>
            `;
        }
        hoursHtml += '</ul>';

        $('.js-findInStoreHours').html(hoursHtml);

        $(modal.modalBox).on('click', '.js-closeFindInStore', (e) => {
            e.preventDefault();
            modal.close();
            modal.destroy();
        });
    });
}

function changeFindInStoreView() {
    $('body').on('click', '.storeLocatorNearbyMap', (e) => {
        $('.findinstore .find-in-store').show();
        $('.findinstore-results .grid-x.result').hide();
        $('.storeLocatorNearbyList').addClass('change-opacity');
        $('.storeLocatorNearbyMap').removeClass('change-opacity');
    });
    $('body').on('click', '.storeLocatorNearbyList', (e) => {
        $('.findinstore-results .grid-x.result').show();
        $('.findinstore .find-in-store').hide();
        $('.storeLocatorNearbyMap').addClass('change-opacity');
        $('.storeLocatorNearbyList').removeClass('change-opacity');
    });
}

/**
 * reorder the swatches in $swatchContainer in order to push the soldout ones at the end
 */
function reorderSwatches($swatchContainer) {
    var $soldoutColorsContainers = $swatchContainer.find('span.swatch-value.soldout').closest('a');
    if ($soldoutColorsContainers.length === 0) {
        return;
    }
    var $lastNonSoldoutColorContainer = $swatchContainer.find('span.swatch-value').closest('a').not($soldoutColorsContainers).last();
    $soldoutColorsContainers.insertAfter($lastNonSoldoutColorContainer);
}

class ProductHelpers {
    constructor() {
        this.methods = {
            editBonusProducts: data => {
                chooseBonusProducts(data);
            },
            getPidValue: $el => {
                return getPidValue($el);
            }
        };
    }

    run() {
        this.colorAttribute();
        this.sizeAttribute();
        this.sizeAttributeSet();
        this.selectAttribute();
        this.quantity();
        this.availability();
        this.addToCartMobile();
        this.addToCart();
        this.addToCartFromSizebay();
        this.trackSizebayCalculateSize();
        this.sizeGuide();
        // this.selectBonusProduct();
        // this.removeBonusProduct();
        // this.enableBonusProductSelection();
        // this.showMoreBonusProducts();
        // this.enableAddAfterBonusColorSelection();
        this.addBonusProductsToCart();
        this.sizeTU();
        this.quickAddListener();
        this.updateAddToCartButton();
        checkColorAttribute();
        NotifyHelper.notifyMeModal();
        this.checkSoldoutAvailability();
        this.showOtherColors();
        this.hideOtherColors();
        this.showCrossellContainerMobileModal();
        SmartGiftHelper.run();
        animationOnStoreLocator();
        createStoreDetailsModal();
        changeFindInStoreView();
        this.orderStatusFormMenu();
        this.registerAttributionTokenSending();
        this.initMasterComposition();
    }

    initMasterComposition() {
        const $root = $('.product-detail').first();
        const $svg = $('.js-svg-urls');

        if (!$root.length || !$svg.length) return;

        const data = $root.data();

        updateCompositionUI(
            {
                careMaintenanceCode: data.careCode,
                partTypes: data.partTypes,
                mainComposition: data.mainComp
            },
            $root.find('.js-composition-info'),
            $('.mobile-container .js-composition-info'),
            $svg.data()
        );
    }

    updateAddToCartButton() {
        $('body').on('product:updateAddToCartButton', function (e, $productContainer) {
            if (!$productContainer) {
                return;
            }

            // Update "Add to cart" button
            $($productContainer).find('button.add-to-cart, button.add-to-cart-quick-add').addClass('added');
            $($productContainer).find('.add-to-cart-label').addClass('hidden');
            $($productContainer).find('.add-to-cart-label-added').removeClass('hidden');

            // Reset after 1 second
            setTimeout(function () {
                $($productContainer).find('button.add-to-cart, button.add-to-cart-quick-add').removeClass('added');
                $($productContainer).find('.add-to-cart-label').removeClass('hidden');
                $($productContainer).find('.add-to-cart-label-added').addClass('hidden');
            }, 3000);
        });
        $('body').on('click', '.js-accordion-size-wrapper .swatch-boolean', e => {
            $('.button.add-to-cart[data-text-addtocart]').each(function () {
                $(this).html($(this).data('text-addtocart'));

                $('.js-accordion-size-wrapper .accordion-title').addClass('size-selected');
            });
        });
    }

    sizeGuide() {
        $('body').on('click', '.js-size-guide', function (e) {
            var styleGuide = $(e.currentTarget).data('style-guide');
            if (styleGuide) {
                var htmlContent = $('#modalFindYourSize').html();
                const modal = newModalFromString(htmlContent, '', ['cc-findYourSizeModal']);
                $(modal.modalBox).addClass('rightModalAttribute rightModalAttribute_sizeMedium');
                if ($('[data-action="Cart-Show"]').length) {
                    $(modal.modalBox).addClass('tingle-modal-box-resized');
                }
                modal.open();
                $('.js-findYourSizeModal-close').on('click', function (e) {
                    e.preventDefault();
                    modal.close();
                });
            } else {
                location.href = $(e.currentTarget).data('href');
            }
            // closing the current modal, that's hiding the newly opened one
            $('.quickview-modal').remove();
        });
    }
    colorAttribute () {
        $('body').on('click', '[data-attr="color"] a.color-variation', e => {
            e.preventDefault();
            if ($(e.currentTarget).attr('disabled') || $(e.currentTarget).children().hasClass('selected')) {
                return;
            }

            var $productContainer = $(e.currentTarget).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.product-detail');
            }

            var dataUrl = $(e.currentTarget).data('url');
            attributeSelect(dataUrl, $productContainer, 'color');

            if ($(e.currentTarget).parents('.product-quickview-bonus-product').length === 0) {
                if (!$('[data-attr="size"] input:checked').closest('.js-accordion-wrapper').hasClass('active-accordion')) {
                    $('[data-attr="size"] input:checked').closest('.js-accordion-wrapper').find('.js-accordion-title').trigger('click');
                }
            }
            if (dataLayer && dataLayer[0]) {
                var wSetupEvent = dataLayer[0];
                dataLayer.push(wSetupEvent);
            }
            $('body').trigger('product:didChangeColor', $productContainer.prevObject);
        });

        $('body').on('click', '.product-detail [data-attr="color"] a', e => {
            if ($(e.currentTarget).parents('.quickview-modal').length !== 0 || $(e.currentTarget).parents('.product-quickview-bonus-product').length !== 0) {
                return;
            }
            // Get new color to push to query string
            var selectedColor = $(e.currentTarget).data('color-value');
            if (!selectedColor) {
                return;
            }
            // Perform URL query string update
            updateProductDetailUrl('_col_', selectedColor);
        });
    }

    sizeAttribute() {
        $('body').on('change', '[data-attr="size"] input', e => {
            e.preventDefault();

            const selectedValue = $(e.currentTarget).attr('value');
            if (selectedValue === 'null') {
                return;
            }
            let selectedSize = ($(e.currentTarget)).siblings('span').find('.size-label').text().trim();
            if (selectedSize) {
                if ($('.quickview-modal').hasClass('tingle-modal--visible') && !$('.product-set').length) {
                    $('.quickview-modal').find('.sizeSelected').html(selectedSize);
                } else if (!$('.choose-bonus-product-dialog').length) {
                    $('.sizeSelected').html(selectedSize);
                }

                $('.sizeSelected').removeClass('hidden');
                $('.product-availability').removeClass('size-not-selected');
                $('.product-availability').find('.availability-msg').addClass('hidden');
                $('.availability-msg-for-small').hide();
                $('.add-to-cart-button-wrapper').find('.add-to-cart').removeClass('disabled');
                $('.js-accordion-size-wrapper .js-createPersonalizationConfirmSize').removeClass('disabled');
                $('.add-to-cart.cart-and-ipay').addClass('ready-to-buy');
            }
            let $productContainer = $(e.currentTarget).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.product-detail');
            }
            attributeSelect(selectedValue, $productContainer, '_', false);
            $('.sizeSelected').removeClass('hidden');
            $('body').trigger('product:didChangeSize', selectedSize);

            if (!e.target.closest('.quickAddToCart-modal')) {
                // do not run this on size change, inside of a complete the look, or complete the promo modal
                if ($('[data-attr="size"] input:checked').closest('.js-accordion-wrapper').hasClass('active-accordion')) {
                    $('[data-attr="size"] input:checked').closest('.js-accordion-wrapper').find('.js-accordion-title').trigger('click');
                }
            }

            if ($(e.currentTarget).closest('.product-quickview-bonus-product').length > 0) {
                $(e.currentTarget).closest('.product-quickview-bonus-product').find('.add-bonus-products').removeClass('disabled').prop('disabled', false);
                $(e.currentTarget).closest('.product-quickview-bonus-product').find('.sizeSelected').html($(e.currentTarget).data('attrValue'));
            }
        });
    }

    sizeAttributeSet() {
        $('.set-size').on('click', function (e) {
            const selectedValue = e.currentTarget.children[0].value;
            if (selectedValue === 'null') {
                return;
            }

            var $productContainer = $(e.currentTarget).closest('.product-detail');
            attributeSelect(selectedValue, $productContainer, '_', false);

            $('body').trigger('product:didChangeSize');
        });
    }

    isSizeSelected() {
        if ($('.page-checkout').length > 0 || $('.cart-page').length > 0 || ($('.product-detail').data('pid') && $('.product-detail').data('pid').indexOf('TU') > -1)) {
            return true;
        }
        return $('[data-attr="size"] input:checked').length > 0;
    };

    oldSizeAttribute() {
        $('body').on('change', '[data-attr="size"] input', e => {
            e.preventDefault();
            // change aria select
            const attrValue = $(e.currentTarget).val();
            const $select = $(e.currentTarget)
                .closest('[data-attr="size"]')
                .find('select');
            const index = $select.find(`option[data-attr-value="${attrValue}"]`).index();

            $select.prop('selectedIndex', index);
            $select.change();
        });
    }

    selectAttribute() {
        $('body').on('change', 'select[class*="select-"], .options-select', e => {
            e.preventDefault();

            var $productContainer = $(e.currentTarget).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    }

    quantity() {
        $('body').on('click', '.quantity-circle', function (e) {
            e.stopImmediatePropagation();
            const $button = $(this);
            const $target = $button.closest('.quantity').find('.quantity-value');
            const $input = $button.closest('.quantity').find('.quantity-select');
            const value = parseInt($target.text());
            if ($button.data('action') === 'increase' && value < 10) {
                $target.text(value + 1);
                $input.val(value + 1);
                if (value + 1 != '10') {
                    $('.quantity-circle[data-action="increase"]').removeClass('disabled');
                    $('.quantity-circle[data-action="decrease"]').removeClass('disabled');
                } else {
                    $('.quantity-circle[data-action="increase"]').addClass('disabled');
                }
                $('.update-cart-url').data('selected-quantity', value + 1);
                $(`[data-opener="QNT"] .attribute-selection`).html(value + 1);
            } else if ($button.data('action') === 'decrease' && value > 1) {
                $target.text(value - 1);
                $input.val(value - 1);
                if (value - 1 != '1') {
                    $('.quantity-circle[data-action="increase"]').removeClass('disabled');
                    $('.quantity-circle[data-action="decrease"]').removeClass('disabled');
                } else {
                    $('.quantity-circle[data-action="decrease"]').addClass('disabled');
                }
                $('.update-cart-url').data('selected-quantity', value - 1);
                $(`[data-opener="QNT"] .attribute-selection`).html(value - 1);
            }
            $input.trigger('change');
        });

        $(function () {
            let quantityDesktop = $('.hide-for-small-only .accordion-panel-group .quantity-value').text().trim();
            let quantityMobile = $('.show-for-small-only .accordion-panel-group .quantity-value').text().trim();
            if (quantityDesktop == '1' || quantityMobile == '1') {
                $('.quantity-circle[data-action="decrease"]').addClass('disabled');
            }
        });
    }

    availability() {
        $('body').on('change', '.quantity-select', e => {
            e.preventDefault();

            var $productContainer = $(e.currentTarget).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer, '_', false);
            }
        });
    }

    isSelectSizeOpen() {
        return $('.attribute-container .js-panel[data-attr="size"]').is(':visible');
    }

    addToCartMobile() {
        $('body').on('click', 'button.add-to-cart.add-to-cart-mobile', (e) => {
            // TEZ Restyling mobile: size modal will always open. Product will be added only after the modal has been opened
            if (!this.isSelectSizeOpen()) {
                if (!$(e.currentTarget).hasClass('product-set')) {
                    // Check if in PDP
                    if ($('.product-wrapper--tezenis').length) {
                        e.preventDefault();
                        e.stopPropagation();
                        $('.descriptionSidebar--tezenis .descriptionSidebar__details .js-panel-opener:eq(1)').trigger('click');
                    }

                    // Always close the modal when a product is added to the cart
                    $('body').on('product:afterAddToCart', (e) => {
                        if (!$('.product-wrapper--tezenis').length) {
                            if (this.sizeModal.modal) {
                                this.sizeModal.close();
                                this.sizeModal.destroy();
                            }
                        }
                    });
                }
            } else {
                if (!this.isSizeSelected()) {
                    return;
                }

                $('body').trigger('product:beforeAddToCart', e.currentTarget);

                let pid = getPidValue($(e.currentTarget));

                var $productContainer = $(e.currentTarget).closest('.product-detail');

                if (!$productContainer.length) {
                    $productContainer = $(e.currentTarget).closest('.quickview-modal').find('.product-detail');
                }

                if (!$productContainer.length) {
                    $productContainer = $('.quickview-modal').find('.product-detail');
                }

                if (!$productContainer.length) {
                    $productContainer = $('.product-detail');
                }

                let addToCartUrl = getAddToCartUrl();

                let uid = $(e.currentTarget).data('uid');

                var pidSet;
                var buttonAdd = $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global');

                for (var i = 0; i < buttonAdd.length; i++) {
                    if (uid === $(buttonAdd[i]).data('uid')) {
                        pidSet = $(buttonAdd[i]).attr('data-pid');
                    }
                }

                const GTMItem = getGtmData({
                    item_id: $('.analytics.product').attr('data-item_id'),
                    item_variant: $('.analytics.product').attr('data-item_variant')
                });

                var form = {
                    pid: pid || pidSet,
                    childProducts: getChildProducts(),
                    quantity: getQuantitySelected($(e.currentTarget)),
                    uuid: uid,
                    GTMItemListName: GTMItem.item_list_name,
                    GTMItemListId: GTMItem.item_list_id,
                    GTMIndex: GTMItem.index
                };

                if (!$('.bundle-item').length) {
                    form.options = getOptions($productContainer);
                }

                $(e.currentTarget).trigger('updateAddToCartFormData', form);
                $('body').trigger('updateQuickAddToCartModal', form);
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: data => {
                            handlePostCartAdd(data);
                            $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer });
                            $('body').trigger('product:updateAddToCartButton', $productContainer);

                            // Reset "Select size" modal
                            $('.js-panel[data-attr="size"]').addClass('hidden').find('input').prop('checked', false);
                            $('.attribute-container.quantity .quantity-value').text('1');
                            $('.attribute-container select.quantity-select').prop('selectedIndex', 0).trigger('change');

                            $.spinner().stop();
                            if ($(e.currentTarget).closest('.js-complete-your-promo').length > 0) {
                                $(e.currentTarget).closest('.js-complete-your-promo').find('.js-added-text').removeClass('hidden');
                                $(e.currentTarget).parent().hide();
                            }
                        },
                        error: () => {
                            $.spinner().stop();
                        }
                    });
                }
            }
        });
    }

    addToCart() {
        $('body').on('click', 'button.add-to-cart:not(.add-to-cart-mobile), button.add-to-cart-global', (e) => {
            let addToCartUrl;
            let pid;
            let pidsObj;
            let setPids;

            // Simulate disabled button with class to allow click and event
            if (!$(e.currentTarget).hasClass('product-set')) {
                if (($(e.currentTarget).data('disabled') || !this.isSizeSelected()) && $(e.currentTarget).data('pid').indexOf('TU') === -1) {
                    // If no size is selected, open modal to choose one
                    $('.product-availability').addClass('size-not-selected');
                    // Always close the modal when a product is added to the cart
                    $('body').on('product:afterAddToCart', (e) => {
                        if (!($('.product-wrapper--tezenis').length && $(window).width() <= 640)) {
                            if (this.sizeModal && this.sizeModal.modal) {
                                this.sizeModal.close();
                                this.sizeModal.destroy();
                            }
                        }
                    });
                    // Prevent further progress until a size is selected
                    return;
                }
            }

            $('body').trigger('product:beforeAddToCart', e.currentTarget);

            if ($('.set-items').length && $(e.currentTarget).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(e.currentTarget).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(e.currentTarget).find('.product-id').text(),
                            qty: $(e.currentTarget).find('.quantity-select').val(),
                            options: getOptions($(e.currentTarget))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(e.currentTarget));

            var $productContainer = $(e.currentTarget).closest('.product-detail');

            if (!$productContainer.length) {
                $productContainer = $(e.currentTarget).closest('.quickview-modal').find('.product-detail');
            }

            if (!$productContainer.length) {
                $productContainer = $('.quickview-modal').find('.product-detail');
            }

            if (!$productContainer.length) {
                $productContainer = $('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();

            let uid = $(e.currentTarget).data('uid');

            var pidSet;
            var buttonAdd = $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global');

            for (var i = 0; i < buttonAdd.length; i++) {
                if (uid === $(buttonAdd[i]).data('uid')) {
                    pidSet = $(buttonAdd[i]).attr('data-pid');
                }
            }

            var promoId = $('.js-promo-msg').data('promotion-id') || null;
            var closeModaleMobile = false;
            var urlCall = null;
            var pidOld = null;
            if ($(e.currentTarget).hasClass('js-close-modale-mobile')) {
                $(e.currentTarget).closest('.js-completeThePromo-modal').find('.js-close').trigger('click');
                urlCall = $(e.currentTarget).data('url-promo');
                pidOld = $(e.currentTarget).data('old-pid');
                pid = $(e.currentTarget).data('pid');
            }
            const GTMItem = getGtmData({
                item_id: $('.analytics.product').attr('data-item_id'),
                item_variant: $('.analytics.product').attr('data-item_variant')
            });

            var form = {
                pid: pid || pidSet,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(e.currentTarget)),
                uuid: uid,
                promoId,
                GTMItemListName: GTMItem.item_list_name,
                GTMItemListId: GTMItem.item_list_id,
                GTMIndex: GTMItem.index
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            var completeYourPromo = $('.js-complete-your-promo');
            if (completeYourPromo.length > 0) {
                $('.js-complete-the-promo-status').val($('.js-complete-the-promo-status').val() - form.quantity);
                form.completePromoItems = $('.js-complete-the-promo-status').val();
                $('.js-updatedProductLeft').text(form.completePromoItems);
                $productContainer.addClass('analytics-complete-the-promo');
            }

            var $analyticsContainer;
            if (completeYourPromo.length) {
                var promoProdId = $(e.currentTarget).data('pid');
                $analyticsContainer = $(`div[data-pid="${promoProdId}"]`).find('.analytics.productListingItem').data();
            } else {
                $analyticsContainer = $(e.currentTarget).closest('.product-detail').siblings('.product.analytics').data();
            }

            $(e.currentTarget).trigger('updateAddToCartFormData', form);
            $('body').trigger('updateQuickAddToCartModal', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        data.promoId = promoId;
                        if (!closeModaleMobile) {
                            handlePostCartAdd(data);
                            if ($(e.currentTarget).closest('.js-complete-your-promo').length > 0) {
                                $(e.currentTarget).closest('.js-complete-your-promo').find('.js-added-text').removeClass('hidden');
                                $(e.currentTarget).parent().hide();
                            }
                            $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer, $analyticsContainer });

                            $.spinner().stop();
                            if ($('.page').data('action') === 'Cart-Show' && $('.js-complete-your-promo-modal').length === 0) {
                                window.location.reload();
                            }
                            if ($('.page').data('action') === 'Product-Show' && $('.close-modal-size').length > 0) {
                                $('.close-modal-size').trigger('click');
                            }
                            if ($('.js-complete-your-promo-quick-view').length > 0) {
                                $('.js-complete-your-promo-quick-view .close-custom').trigger('click');
                            }
                        } else {
                            $.spinner().stop();
                            $('.js-pdp-complete-mobile-removeProduct[data-old-pid="' + pidOld + '"]').removeClass('hide').attr('data-pid', pid);
                            handlePostCartAddCompletePromo(data);

                            $.ajax({
                                url: urlCall,
                                method: 'GET',
                                data: { pid: form.pid },
                                success: html => {
                                    var completePromo = html.promoMessage;
                                    if (completePromo) {
                                        $('.js-noCompletePromo').addClass('hide');
                                        $('.js-completePromo').removeClass('hide');
                                    } else {
                                        $('.js-noCompletePromo').removeClass('hide');
                                        $('.js-completePromo').addClass('hide');
                                    }
                                },
                                error: () => {

                                }
                            });
                        }
                    },
                    error: () => {
                        $.spinner().stop();
                    }
                });
            }
        });
        $('body').on('click', '.js-change-size', function (e) {
            var sku = $(e.currentTarget).data('sku-value');
            var oldPid = $(e.currentTarget).data('old-pid');
            $('.js-change-size').removeClass('selected');
            $(e.currentTarget).addClass('selected');
            $('.js-close-modale-mobile[data-old-pid="' + oldPid + '"]').attr('data-pid', sku).removeClass('disabled').data('disabled', false);
            $('.js-completeThePromo-modal-addToCart-btn').removeClass('disabled');
            $(e.currentTarget).closest('.cc-quickAddToCart-modal, .cc-completeThePromo-modal').find('.js-quickAdd-footer_confirm').removeClass('disabled');
            $('.js-completeThePromo-modal-size-selected').text($(e.currentTarget).find('.js-size-label').text()).removeClass('hidden');
            $('.js-completeThePromo-modal-size-value').addClass('hidden');
        });
    }

    /**
     * When u user clicks on add to cart button, inside sizebay modal, sizebay sends 'sizebay_add_to_cart'.
     */
    addToCartFromSizebay() {
        window.addEventListener('sizebay_add_to_cart', function (e) {
            // Recommendation drawers (mobile devices)
            if ($('.cc-quickAddToCart-modal').length) {
                $('.cc-quickAddToCart-modal .sizes-container .radio-label[data-attr-display-value-for-sizebay="' + e.detail.size + '"]').trigger('click');
            // Complete the look/promo, on top of main PDP image (mobile devices)
            } else if ($('.cc-completeThePromo-modal').length) {
                $('.cc-completeThePromo-modal .sizes-container .radio-label[data-attr-display-value-for-sizebay="' + e.detail.size + '"]').trigger('click');
            // PDP product
            } else {
                $('.js-accordion-size-wrapper .js-size-container .radio-label[data-attr-display-value-for-sizebay="' + e.detail.size + '"]').trigger('click');
            }

            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        // The product will be added to the cart, once the spinner from size selection dissapears.
                        const veil = document.querySelector('div.veil:not(.show-for-small-only)')
                        if (!veil) {
                            observer.disconnect();

                            // Recommendation drawers (mobile devices)
                            if ($('.cc-quickAddToCart-modal').length) {
                                $('.cc-quickAddToCart-modal .add-to-cart-global').trigger('click');
                            // Complete the look/promo, on top of main PDP image (mobile devices)
                            } else if ($('.cc-completeThePromo-modal').length) {
                                $('.cc-completeThePromo-modal .add-to-cart').trigger('click');
                            // PDP product
                            } else {
                                $('.add-to-cart-container .add-to-cart').trigger('click');
                            }
                        }
                    }
                }
            });
    
            const parentContainer = document.querySelector('body');
            if (parentContainer) {
                observer.observe(parentContainer, { childList: true, subtree: true });
            }
        });
    }

    trackSizebayCalculateSize() {
        window.addEventListener('message', function (e) {
            if (e.origin === 'https://vfr-v3-production.sizebay.technology' && e.data === 'szb-recommendation-done-in-app') {
                $('body').trigger('product:calculateSize');
            }
        });
    }

    sizeTU() {
        if (document.getElementById('_t_u')) {
            document.getElementById('_t_u').click();
        }
    }

    addBonusProductsToCart() {
        $('body').on('click', '.add-bonus-products', function () {
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var Qty = $('.choice-of-bonus-product .bonus-quantity-select').length > 0 ? parseInt($(this).parents('.choice-of-bonus-product').eq(0).find('.bonus-quantity-select').val(), 10) : 1;
            var pid = $(this).parents('.choice-of-bonus-product').length > 0 && $(this).parents('.choice-of-bonus-product').data('pid') ? $(this).parents('.choice-of-bonus-product').data('pid') : $(this).parents('.product-quickview-bonus-product').data('variant-pid');
            if ((pid.indexOf('color') > -1 || $(this).closest('.product-quickview-bonus-product').hasClass('product-master')) && $('.product-quickview-bonus-product .sizes-container input[type="radio"]:checked').data('sku') !== '0.0') {
                pid = $(this).closest('.product-quickview-bonus-product').find('.sizes-container input[type="radio"]:checked').data('sku');
            }
            var size = $(this).closest('.product-quickview-bonus-product').find('.sizes-container input[type="radio"]:checked').data('attr-value');
            const page = $('.page').data('action') === 'Search-Show' ? 'plp' : $('.page').data('action') === 'Product-Show' ? 'pdp' : 'cart';

            var pidsObject = {
                bonusProducts: [{
                    pid: pid,
                    qty: Qty,
                    size: size,
                    options: [null],
                    GTMItemListName: 'free_product',
                    GTMItemListId: page,
                    GTMIndex: 0
                }],
                totalQty: Qty
            };

            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: data => {
                    $('.bonus-product-modal').find('.close-custom').trigger('click');
                    if (data.error) {
                        $('.error-choice-of-bonus-products')
                            .html(data.errorMessage);
                    } else {
                        data.isBonusProductAdd = true;
                        handlePostCartAdd(data);
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');

                        $('body').trigger('product:afterAddToCart', {
                            ...data,
                            form: {
                                quantity: pidsObject.bonusProducts[0].qty
                            },
                            $productContainer: 'bonus_product'
                        });
                    }
                    bonusProductModal && bonusProductModal.destroy();
                    location.reload();
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    }

    quickAddListener() {
        $('body').on('click', 'button.add-to-cart-quick-add', function (e) {
            e.preventDefault();

            if ($(this).hasClass('added')) {
                return;
            }

            let isSizeSelected = ($(this).attr('data-size-selected') === 'true');
            let pid = $(this).attr('data-pid');
            let url = $(this).attr('data-get-url');
            let uid = $(this).attr('data-uid');

            if (!isSizeSelected) {
                showQuickAddItems(pid, url);

                if ($(this).closest('.layer-complete-your-promo-modal').length > 0 && !Foundation.MediaQuery.atLeast('medium')) {
                    $('.suggested-products').addClass('modal-size-open');
                }

                return;
            }

            // Add to cart
            $('body').trigger('product:beforeAddToCart', e.currentTarget);

            let $productContainer = $(e.currentTarget).closest('.product-detail-quick-add');
            let quantitySelected = 1;
            let addToCartUrl = getAddToCartUrl();

            const GTMItem = getGtmData({
                item_id: $('.analytics.product').attr('data-item_id'),
                item_variant: $('.analytics.product').attr('data-item_variant')
            });

            var form = {
                pid: pid,
                childProducts: getChildProducts(),
                quantity: quantitySelected,
                uuid: uid,
                GTMItemListName: GTMItem.item_list_name,
                GTMItemListId: GTMItem.item_list_id,
                GTMIndex: GTMItem.index
            };

            $(e.currentTarget).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        $.spinner().stop();
                        if (data.error) {
                            $productContainer.find('.response-error-quick-add').removeClass('hidden');
                        } else {
                            $('body').trigger('product:afterAddToCart', {
                                ...data,
                                form,
                                $productContainer
                            });
                            data.quantityTotal = data.cart.numItems;
                            handlePostCartAdd(data);

                            if (!Foundation.MediaQuery.atLeast('medium')) {
                                $productContainer = $('#crossSellVariation button.add-to-cart-quick-add[data-pid="' + pid + '"').closest('.product-detail-quick-add');
                            }

                            $('body').trigger('product:updateAddToCartButton', $productContainer);
                        }
                    },
                    error: () => {
                        $.spinner().stop();
                    }
                });
            }
        });

        $('body').on('click', '.closeQuickSize', function (e) {
            e.preventDefault();
            $('.select-size-quick-add-container').addClass('hidden').empty();
            $('.suggested-products').removeClass('modal-size-open');
        });

        $('body').on('change', '[data-attr="size_qa"] input ', e => {
            e.preventDefault();

            const selectedValue = $(e.currentTarget).attr('value');
            if (selectedValue === 'null') {
                return;
            }

            let $productContainer = $(e.currentTarget).closest('.product-detail-quick-add');
            if ($productContainer && $productContainer.length > 0) {
                attributeSelectQuickAdd(selectedValue, $productContainer, '_', false);
                $productContainer.find('.add-to-cart-quick-add').attr('data-size-available', true);
            }
        });
    }

    checkSoldoutAvailability() {
        if ($('.page').data('action') !== 'Product-Show') {
            return;
        }
        var $productContainer = $('div.product-detail.container').first();
        var attributesUpdateUrl = $productContainer.data('variationAttrUpdate');
        if (!attributesUpdateUrl) {
            return;
        }
        $.ajax({
            url: attributesUpdateUrl,
            method: 'GET',
            dataType: 'json',
            success: data => {
                if (data.product && data.product.variationAttributes) {
                    updateAttrs(data.product.variationAttributes, $productContainer);
                    updateAvailability(data, $productContainer);
                    $('body').trigger('product:updateAddToCart', {
                        product: data.product,
                        $productContainer: $productContainer
                    });
                    // reorder swatches in order to push soldout colors in the laste positions
                    reorderSwatches($('.on-sale-color-attr'));
                    reorderSwatches($('.not-sale-color-attr'));
                }
            }
        });
    }

    showOtherColors() {
        $('body').on('click', '.js-showOtherColors', (e) => {
            $('.color-variation').removeClass('hideGreatThanFive');
            $(e.currentTarget).addClass('hidden');
            $('.js-hideOtherColors').removeClass('hidden');
        });
    }

    hideOtherColors() {
        $('body').on('click', '.js-hideOtherColors', (e) => {
            $('.color-variation').addClass('hideGreatThanFive');
            $(e.currentTarget).addClass('hidden');
            $('.js-showOtherColors').removeClass('hidden');
        });
    }

    showCrossellContainerMobileModal() {
        $('body').on('click', '.js-pdp-complete-mobile-removeProduct', (e) => {
            e.preventDefault();
            var encodedUrl = $(e.currentTarget).data('href');
            var pid = $(e.currentTarget).data('pid');
            var urlCall = $(e.currentTarget).data('url-promo');
            var pidOld = $(e.currentTarget).data('old-pid');

            $.ajax({
                url: encodedUrl,
                data: {
                    pid: pid
                },
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    $('.js-pdp-complete-mobile-removeProduct[data-old-pid="' + pidOld + '"]').addClass('hide');
                    handlePostCartAddCompletePromo(data);
                    $.ajax({
                        url: urlCall,
                        method: 'GET',
                        success: html => {
                            var completePromo = html.promoMessage;
                            if (completePromo) {
                                $('.js-noCompletePromo').addClass('hide');
                                $('.js-completePromo').removeClass('hide');
                            } else {
                                $('.js-noCompletePromo').removeClass('hide');
                                $('.js-completePromo').addClass('hide');
                            }
                        },
                        error: () => {

                        }
                    });
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
        $('body').on('click', '.js-pdp-complete-mobile', (e) => {
            let headerClone;
            if ($(e.currentTarget).hasClass('js-isPromoFilmstrip')) {
                headerClone = $('.carousel-header.promo-header').clone();
            } else {
                headerClone = $('.carousel-header').clone();
            }
            let htmlContent = '<div class="cross-sell-header">' + headerClone.html() + '</div>';
            htmlContent += '<div id="completeTheLook"></div>';
            const modal = newModalFromString(htmlContent, false, ['pdpCompleteMobileModal', 'js-noScroll']);
            if ($('#crossSellVariation').length > 0) {
                let crossSellSlider = $('#promoSlider').length ? '#promoSlider' : '#lookSlider';
                const $s = $(crossSellSlider);
                if ($s.hasClass('slick-initialized')) {
                    $s.slick('unslick');
                }

                $(crossSellSlider)
                    .find('.crosssell-view')
                    .clone()
                    .appendTo('#completeTheLook');

                const $bottomContainer = $('#completeTheLook');
                $bottomContainer.slick({
                    slidesToShow: 2.3,
                    slidesToScroll: 1,
                    infinite: false,
                    draggable: true,
                    arrows: true,
                    prevArrow: mobileSlickArrowPrev,
                    nextArrow: mobileSlickArrowNext,
                    slide: '.crosssell-view',
                    touchThreshold: 100
                });
            }
            $(modal.modalBox).find('.tingle-modal__closeIcon').removeClass('hidden');
            if ($(e.currentTarget).hasClass('js-isPromoFilmstrip')) {
                $(modal.modal).addClass('cc-completeThePromo');
                $(modal.modalBox).find('.plp-wishlist.plp-wishlist--tezenis').addClass('js-completeToPromoWishlist');
            }
            $(modal.modalBox).find('button.js-quick-add').removeClass('js-quick-add').addClass('js-pdp-complete-mobile-product');

            let slidesCount = $('#completeTheLook').find('.tile-image').length;

            if (slidesCount <= 2) {
                $('.cross-sell-header').addClass('no-margin-bottom');
            }

            modal.open();

            $(modal.modalBox).on('click', '.tingle-modal__closeIcon', (e) => {
                e.preventDefault();
                $(modal.modalBox).find('.tingle-modal__closeIcon').addClass('hidden');
                modal.close();
                modal.destroy();
                if ($('#completeTheLook').hasClass('slick-initialized')) {
                    $('#completeTheLook').slick('unslick');
                    $('#completeTheLook .slick-arrow, #completeTheLook .prev-button, #completeTheLook .next-button').remove();
                }

                if ($('#crossSellVariation').hasClass('slick-initialized')) {
                    $('#crossSellVariation').slick('setPosition');
                }
            });
            $(modal.modalBox).on('click', '.js-pdp-complete-mobile-product', (e) => {
                $.spinner().start();
                e.preventDefault();
                var encodedUrl = $(e.currentTarget).data('href');

                $.ajax({
                    url: encodedUrl,
                    method: 'GET',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        const htmlContent = data.templateMo;
                        // create and open confirmation modal
                        const modalMobile = newModalFromString(htmlContent, false, ['cc-completeThePromo-modal', 'js-completeThePromo-modal'], handleSizebayInjection);
                        modalMobile.open();
                        $('.carousel-inner').slick({
                            dots: false,
                            arrows: true,
                            prevArrow: '<button class="slick-prev custom-prev prev-button" aria-label="Prev" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M8.05469 0.523438L0.742189 7.83594L8.05469 15.1484" stroke="#1C1C1C" stroke-width="1.05" stroke-linecap="round"/></svg></button>',
                            nextArrow: '<button class="slick-next custom-next next-button" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M0.523438 15.1484L7.83594 7.83594L0.523437 0.523439" stroke="#1C1C1C" stroke-width="1.05" stroke-linecap="round"/></svg></button>',
                            slidesToShow: 3.4,
                            draggable: true,
                            infinite: false,
                            slidesToScroll: 3.4,
                            responsive: [
                                {
                                    breakpoint: 769,
                                    settings: {
                                        draggable: true,
                                        slidesToShow: 2.85,
                                        slidesToScroll: 2.85,
                                    }
                                }
                            ]
                        });

                        $('.cc-completeThePromo-modal-color-wrapper').each(function () {
                            const $carousel = $(this);
                            if ($carousel.hasClass('slick-initialized')) {
                                return;
                            }

                            const $container = $carousel.closest('.product-detail');
                            const $prev = $container.find('.color-prev');
                            const $next = $container.find('.color-next');
                            const slideCount = $carousel.children('a.color-variation').length;
                            const maxSlide = 5;
                            const slidesToDisplay = Math.min(slideCount, maxSlide);

                            $carousel.on('init', function () {
                                $prev.toggleClass('slick-hidden', !(slideCount > maxSlide));
                                $next.toggleClass('slick-hidden', !(slideCount > maxSlide));

                                if (slideCount > maxSlide) {
                                    $('.carousel-header__button-wrapper').removeClass('hide');
                                }
                            });

                            $carousel.slick({
                                variableWidth: true,
                                slidesToShow: slidesToDisplay,
                                slidesToScroll: 1,
                                arrows: true,
                                infinite: false,
                                prevArrow: $prev,
                                nextArrow: $next
                            });
                        });

                        $('.js-completeThePromo-modal-selectedColor').text($('.js-completeThePromo-modal-color-swatch.selected + .js-completeThePromo-modal-color-value').text());
                        $(modalMobile.modalBox).find('.js-quantity-selector').removeClass('hidden');

                        $(modalMobile.modalBox).on('click', '.js-close', (e) => {
                            if (modalMobile.modal !== null) {
                                modalMobile.close();
                                modalMobile.destroy();
                            }
                        });
                        $(modalMobile.modalBox).on('click', '.color-variation', (e) => {
                            handleColorVariationClick(e, modalMobile.modalBox);
                        });
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
        });
    }

    orderStatusFormMenu() {
        function openOrderStatusFormMenu() {
            const htmlContent = $('.js-modal-web-order-status-form-request').html();
            var tabContent = $('.js-content-web-order-status-form-request').html();

            const modal = newModalFromString(htmlContent, false, ['wrapperModal', 'tingle-modal-form-request', 'order-status-new-form']);
            modal.open();
            modal.setContent(tabContent);
            $(modal.modalBox).addClass('modal-tabs-style');
            $(modal.modalBox)
                .find('.close-button')
                .on('click', function (e) {
                    modal.close();
                });

            $('.js-inside-close-modal').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        }

        var url = new URL(window.location.href);
        var showOrderStatus = url.searchParams.get('showOrderStatus');

        if (showOrderStatus) {
            openOrderStatusFormMenu();
        }

        $('.js-order-status-form-menu').on('click', function (e) {
            e.preventDefault();
            openOrderStatusFormMenu();
        });

        $('body').on('click', '#form-order-status button', function (e) {
            let errors = [];
            $('#form-order-status :input:not(:button)').each(function (index, value) {
                let validator = $(this).parsley({
                    errorClass: 'is-invalid-input'
                });
                validator.validate();
                if (!validator.isValid()) {
                    errors.push(validator);
                }
            });
            if (errors.length > 0) {
                e.preventDefault();
            }
        });
    }
    registerAttributionTokenSending() {
        $('body').on('click', '.google-carousel .js-pdp-link', function () {
            const attributionToken = $(this).closest('.google-recommendations-wrapper').find('.attribution-token').data('attributionToken');
            createCookie('attribution_token', attributionToken);
        });
    }
}

const productHelpers = new ProductHelpers();
export default productHelpers;
